import React from 'react'

import { VideoTrack } from '../../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useHumanParticipants } from '../../../../../webrtc/webRTCRoom'

import './FocusParticiants.scss'

interface FocusParticipantsProps {
  participantIds: readonly number[]
}

const FocusParticipants = ({ participantIds }: FocusParticipantsProps) => {
  const participants = useHumanParticipants()

  return (
    <div className="focus-participants-pane">
      {participants
        .filter((p) => participantIds.includes(p.id))
        .map((p) => (
          <div className="focus-participant-feed" key={p.id}>
            {p.tracks.camera && (
              <VideoTrack track={p.tracks.camera} objectFit="cover" />
            )}
            <div className="focus-participant-name">{p.name}</div>
          </div>
        ))}
    </div>
  )
}

export { FocusParticipants }
